/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import base64 from "react-native-base64"
import establishment from "../../functions/logic/Business"
import Spiner from "../../components/Spiner"
import generalFunctions from "../../functions/logic/general"

export default function Establishment() {
    const [spiner, setSpiner] = useState(false)
    const [table, setTable] = useState([])
    const userToken = localStorage.getItem("userToken")

    useEffect(() => {
        setSpiner(true)
        getEstablishment()
        setSpiner(false)
    }, [])

    const getEstablishment = async () => {
        const response = await establishment.establishmentLogic(userToken)
        const ip = await generalFunctions.getIpClient()
        localStorage.setItem("ip", ip["ipString"])
        setTable(response)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <div className="content-wrapper">
                <section className="content-header"></section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">{global.STITLE}</h3>
                                    </div>
                                    <div className="card-body">
                                        {/* Contenedor responsivo de la tabla */}
                                        <div className="table-responsive">
                                            <table id="establishmentData" className="table table-bordered table-striped table-hover w-100">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center col-md-2">RUC</th>
                                                        <th className="text-center col-md-3">Establecimiento</th>
                                                        <th className="text-center col-md-4">Razón Social(s)</th>
                                                        <th className="text-center col-md-3">Nombre Comercial</th>
                                                        <th className="text-center col-md-2">Estado</th>
                                                        <th className="text-center col-md-2">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(table).map(([key, subject], i) => (
                                                        <tr key={i}>
                                                            <td className="text-center">{subject.identification}</td>
                                                            <td className="text-center">{subject.establishment}</td>
                                                            <td className="text-center">{subject.name}</td>
                                                            <td className="text-center">{subject.comercialName}</td>
                                                            <td className="text-center">{subject.case}</td>
                                                            <td className="text-center">
                                                                <a href={'empresa/modulos/' + base64.encode(subject.id)} className="btn btn-primary btn-sm">
                                                                    <i className="fas fa-edit"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}
